import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives/compiled';
import {
	PopoverContent,
	PopoverProvider,
	PopoverTarget,
	SpotlightActions,
	SpotlightBody,
	SpotlightCard,
	SpotlightControls,
	SpotlightDismissControl,
	SpotlightFooter,
	SpotlightHeader,
	SpotlightHeadline,
	SpotlightMedia,
	SpotlightPrimaryAction,
	SpotlightSecondaryAction,
	SpotlightStepCount,
} from '@atlaskit/spotlight';
import Image from '@atlaskit/image';

import homeLight from '../../assets/images/Home.gif';
import homeDark from '../../assets/images/Home-dark.png';
import { spotlight, editorForYouSpotlight } from '../../messages';
import { useTour } from '../../hooks/useNthUserOrientationStore';

interface EditorForYouSpotlightProps {
	children: ReactNode;
}
const STEP_ID = 'nth-user-orientation-editor-for-you-spotlight';
export const EditorForYouSpotlight: React.FC<EditorForYouSpotlightProps> = ({ children }) => {
	const { reset, next, back, currentStep, progress } = useTour(STEP_ID);
	const { formatMessage } = useIntl();
	const isVisible = currentStep === STEP_ID;

	return (
		<PopoverProvider>
			<PopoverTarget>{children}</PopoverTarget>
			<PopoverContent
				shouldDismissOnClickOutside={false}
				next={next}
				back={back}
				dismiss={reset}
				placement="right-end"
				offset={[0, 24]}
				isVisible={isVisible}
			>
				<SpotlightCard testId={STEP_ID}>
					<SpotlightHeader>
						<SpotlightHeadline>{formatMessage(editorForYouSpotlight.headline)}</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightMedia>
						<Image src={homeLight} srcDark={homeDark} alt="" />
					</SpotlightMedia>
					<SpotlightBody>
						<Text>{formatMessage(editorForYouSpotlight.body)}</Text>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightStepCount>{formatMessage(spotlight.progress, progress)}</SpotlightStepCount>
						<SpotlightActions>
							<SpotlightSecondaryAction>{formatMessage(spotlight.back)}</SpotlightSecondaryAction>
							<SpotlightPrimaryAction>{formatMessage(spotlight.next)}</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
